<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2024-03-19 12:37:25
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 11:17:25
 * @FilePath: \jyrg-web\src\components\public\VoucherCenter\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="mainConrder" >
    <div id="maskConrder">
      <transition name="el-zoom-in-top">
      <div class="map-order">
        <img
          class="close"
          src="../../../../assets/image/pc/close.png"
          alt=""
          @click="close(false)"
        />
        <img
          class="orderLink"
          src="../../../../assets/image/pc/order/orderLink-01.png"
          alt=""
        />
      </div>
      </transition>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => {
      
        return true;
      },
    },
  },
  data() {
    return {
    };
  },

  mounted() {},
  methods: {
    close() {
      this.$emit("close", false);
          
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1280px) {
  #maskConrder {
    position: absolute;
    top: 0;
    min-width: 1920px;
    height: 100vh;
    display: block;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 9999;
  }

  .map-order {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 541px;
      height: 430px;
      background: url("~@/assets/image/pc/order/basemap-orderlink-code-01.png");
      background-size: 100% 100%;
      margin-top: 15%;
      margin-left:38%;
      z-index: 9997;
      .orderLink {
        width: 155px;
        height: 155px;
      }
      .close {
        position: absolute;
        width: 24px;
        height: 27px;
        top: -5%;
        right: -5%;
        transform-origin: 50% 50%;
        transition: transform 0.5s ease;
      }
      .close:hover {
        transform: rotate(180deg);
      }

      @keyframes close {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(90deg);
        }
      }
    }

}


</style>
